import {CardsMapChildrenProps} from 'common/src/components/CLCardsMap/CardsMapContainer/CardsMapContainer.types';
import {CampaignStep, CampaignStepApprovalStatus} from './campaignWorkflow.enums';
import {ReactNode} from 'react';
import {CampaignType} from '../campaigns/campaigns.types';
import {FeatureFlagKey} from '../featureFlags/featureFlags.types';
import {CLRoute} from '../routing/routing.types';

interface CampaignStepConfigContent {
  element: React.LazyExoticComponent<
    (props: CardsMapChildrenProps | Record<string, never>) => React.JSX.Element
  >;
  title?: ReactNode;
  backButton?: ReactNode;
  headerButtons?: (props: {
    campaignType: CampaignType;
    enabledFlags: Set<FeatureFlagKey>;
  }) => ReactNode;
}

interface CampaignStepConfig {
  icon: string;
  name: string;
  description: string;
  path: CLRoute;
  isRequired: boolean;
  isRequireApproval: boolean;
  isSupportComment: boolean;
  showCommentsInCampaignInfo: boolean;
  isSupportPreview: boolean;
}

interface CampaignWorkflowConfig extends Partial<CampaignStepConfig> {
  isTreePage: boolean;
  content: CampaignStepConfigContent;
  path: CLRoute;
}

interface CampaignWorkflowApprover {
  id: number;
  firstName: string;
  lastName: string;
  profilePictureUrl: string;
  status: CampaignStepApprovalStatus;
  comment: string;
}

interface CampaignWorkflowUserApproval {
  comment: string;
  status: CampaignStepApprovalStatus;
  userId: number;
}

interface CampaignWorkflowData {
  status: CampaignStepApprovalStatus;
  step: CampaignStep;
  updatedBy: number;
  updatedByUserName: string;
  userApprovals: CampaignWorkflowUserApproval[];
}

type CampaignWorkflowDataByStep = Record<CampaignStep, CampaignWorkflowData>;

enum CampaignWorkflowSearchParamKey {
  Steps = 'steps',
  FocusedStep = 'focusedStep',
}

export {
  CampaignWorkflowData,
  CampaignWorkflowDataByStep,
  CampaignWorkflowUserApproval,
  CampaignStepConfig,
  CampaignWorkflowConfig,
  CampaignWorkflowApprover,
  CampaignWorkflowSearchParamKey,
};
